<template>
  <div>
    <v-card class="d-flex justify-center mb-1 mt-1">
      <v-card class="d-flex justify-center flex-grow-1" flat>
        <v-card flat class="pa-2">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            clearable
            :label="$t('message.common.cid')"
            v-model="search_cid"
          >
          </v-text-field>
        </v-card>
        <v-card flat class="pa-2">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            clearable
            :label="$t('message.common.title')"
            v-model="search_corpus"
          >
          </v-text-field>
        </v-card>
      </v-card>
      <v-card class="align-self-center mr-1" flat>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" class="ma-2" @click="$emit('update_corpuses_select', []); get_data('corpus', []);">
              mdi-refresh
            </v-icon>
          </template>
          <span>{{ $t("message.common.refresh") }}</span>
        </v-tooltip>
        <template v-if="upload_refer !== null">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="ma-2" @click="$router.push('/corpus/import?referer=/' + upload_refer)">
                mdi-import
              </v-icon>
            </template>
            <span>{{ $t("message.common.import") }}</span>
          </v-tooltip>
        </template>
      </v-card>
    </v-card>
    <v-data-table
      :value="selected_corpus"
      item-key="cid"
      :headers="headers"
      :items="data"
      :sort-by="sort_by"
      :sort-desc="sort_desc"
      must-sort
      class="elevation-1"
      :single-select="false"
      @click:row="select_row"
      :footer-props="{
        'items-per-page-options': [5, 10, 15, 100]
      }"
    >
      <template v-slot:item.priority="{ item }">
        <template v-if="item.priority !== null">
          <div class="circle">
            {{ item.priority }}
          </div>
        </template>
      </template>
      <template v-slot:item.cid="{ item }">
        {{ item.cid }}
      </template>
      <template v-slot:item.name="{ item }">
        <template v-if="item.name.length <= 40">
          {{ item.name }}
        </template>
        <template v-else>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ item.name.substr(0, 40) }}...
              </span>
            </template>
            <span>{{ item.name }}</span>
          </v-tooltip>
        </template>
      </template>
      <template v-slot:item.lang_pair="{ item }">
        {{ $t("message.common.lang_" + item.lang_pair[0]) }}
        ,&nbsp;
        {{ $t("message.common.lang_" + item.lang_pair[1]) }}
      </template>
      <template v-slot:item.line="{ item }">
        {{ item.line }}
      </template>
      <template v-slot:item.ctime="{ item }">
        {{ $d(1000 * item.ctime, 'long', $store.getters.langs[$i18n.locale].locale) }}
      </template>
      <template v-slot:item.operation="{ item }">
        <template v-if="
          mode === 'user'
          && operations.indexOf('train_this') >= 0
        ">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="ma-2" @click.stop="$router.push('/train?corpus=' + item.cid)">
                mdi-brain
              </v-icon>
            </template>
            <span>{{ $t("message.corpus.train_this") }}</span>
          </v-tooltip>
        </template>
        <!--
        <template v-if="
          mode === 'user'
          && item.extensions.indexOf('json') >= 0
          && deletable(item)
          && operations.indexOf('edit_corpus') >= 0
        ">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="ma-2" @click.stop="$router.push('/editor/corpus/' + item.cid + '?referer=' + nav_path)">
                mdi-book-open
              </v-icon>
            </template>
            <span>{{ $t("message.corpus.edit_corpus") }}</span>
          </v-tooltip>
        </template>
        -->
        <template v-if="
          deletable(item)
          && operations.indexOf('delete') >= 0
        ">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="ma-2" @click.stop="confirm_delete_data(get_prefix() + 'corpus', [item.cid], get_id())">
                mdi-delete
              </v-icon>
            </template>
            <span>{{ $t("message.common.delete") }}</span>
          </v-tooltip>
        </template>
        <template v-if="
          operations.indexOf('preview') >= 0
        ">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="ma-2" @click.stop="$refs.parallel_viewer && $refs.parallel_viewer.open(item.name, 'corpus', item.cid)">
                mdi-file-find
              </v-icon>
            </template>
            <span>{{ $t("message.viewer.preview") }}</span>
          </v-tooltip>
        </template>
      </template>
      <template v-slot:footer.prepend>
        <v-card v-if="multiple" flat class="pl-3">
          {{ $t("message.common.selecting", { cur: selected_corpus.length, max: max_select }) }}
          <template v-if="select_one && selected_corpus.length < 1">
            <br />
            <span class="red--text">
              ({{ $t("message.common.select_one") }})
            </span>
          </template>
          <template v-if="selected_corpus.length > max_select">
            <br />
            <span class="red--text">
              ({{ $t("message.common.over_selecting", { max: max_select }) }})
            </span>
          </template>
        </v-card>
      </template>
    </v-data-table>
    <p class="text-right pt-5 pr-3">
      <v-btn
        @click="clear_all()"
      >
        {{ $t("message.common.clear_all") }}
      </v-btn>
    </p>
    <ParallelViewer
      ref="parallel_viewer"
      :mode="mode"
    ></ParallelViewer>
    <Confirm
      ref="delete_confirm"
      :message="$t('message.common.delete_confirm')"
      :positive="$t('message.common.yes')"
      :negative="$t('message.common.no')"
    >
    </Confirm>
    <v-overlay
      :absolute="true"
      :value="progress_overlay"
    >
      <v-progress-circular
        :value="progress"
      >
        {{ progress }}
      </v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import ParallelViewer from '../components/ParallelViewer';
import Confirm from '../components/Confirm';
import { res_list } from "../js/res_list";
import { http_error } from "../js/http_error";


export default {
  name: 'priority_corpus_select',
  mixins: [res_list, http_error],
  components: {
    ParallelViewer,
    Confirm
  },
  props: {
    selected_corpus: Array,
    file_type: String,
    multiple: Boolean,
    lang_pairs: Array,
    mode: String,
    select_one: Boolean,
    max_select: Number,
    operations: {
      type: Array,
      default: () => { return ['preview']; }
    },
    upload_refer: {
      type: String,
      default: null
    }
  },
  data: function(){
    return {
      module_id: "71",
      data: [],
      progress: 0,
      progress_overlay: false,
      search_cid: "",
      search_corpus: "",
      sort_by: ['ctime'],
      sort_desc: [true]
    }
  },
  mounted: function(){
    this.get_data("corpus", []);
  },
  methods: {
    get_data: function(module, extra_path) {
      this.progress_overlay = true;
      this.progress = 0;
      this.data = [];
      this.$http.get(this.$store.getters.api_endpoint + "/" + module + extra_path,
                     {
                       onDownloadProgress: function( progressEvent ) {
                         this.progress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ));
                       }.bind(this)
                     })
        .then( response => {
          this.progress = 100;
          this.progress_overlay = false;
          if(this.$store.getters.debug){
            console.log("response.data:" + JSON.stringify(response.data));
          }
          var data = [];
          for(var d of response.data){
            if(d.type !== "corpus"){
              continue;
            }
            d.priority = null;
            if(this.selected_corpus.length > 0){
              for(var corpus of this.selected_corpus){
                if(d.cid === corpus.cid){
                  d.priority = corpus.priority;
                }
              }
            }
            data.push(d);
          }
          this.data = data;
        })
        .catch( error => {
          this.progress_overlay = false;
          if(this.http_error(error)){
            // 404だと何もしない
            if(error.response.status !== 404){
              this.$store.commit("setNotification", {
                type: "error",
                message: error.response.data
              });
            }
          }
        });
    },
    select_row: function(event){
      var index;
      for(var [i, d] of this.data.entries()){
        if(d.cid === event.cid){
          index = i;
          break;
        }
      }
      var modified = false;
      if(this.data[i].priority !== null){
        var current_priority = this.data[index].priority;
        for(var d of this.data){
          if(d.priority !== null && d.priority > current_priority){
            d.priority--;
          }
        }
        this.data[index].priority = null;
        modified = true;
      }else if(this.max_priority < this.max_select){
        var select_data = { ...this.data[index], ...{ priority: this.max_priority + 1 } };
        this.data.splice(index, 1, select_data);
        modified = true;
      }
      if(modified){
        var result = [];
        for(var d of this.data){
          if(d.priority === null){
            continue;
          }
          result[d.priority - 1] = {
            cid: d.cid,
            name: d.name
          }
        }
        this.$emit("update_corpuses_select", result);
      }
    },
    clear_all: function(){
      for(var d of this.data){
        d.priority = null;
      }
      this.$emit("update_corpuses_select", []);
    }
  },
  computed: {
    headers: function() {
      return [
        {
          text: this.$i18n.t("message.common.priority"),
          value: 'priority',
          sort: (a, b) => {
            if(a === null && b === null){
              return 0;
            }else if(a === null && b !== null){
              return b;
            }else if(a !== null && b === null){
              return -a;
            }else{
              return a - b;
            }
          }
        },
        {
          text: this.$i18n.t("message.common.cid"),
          value: 'cid',
          filter: value => {
            if(this.search_cid === "" || this.search_cid === null){
              return true;
            }
            return value.indexOf(this.search_cid) !== -1;
          }
        },
        {
          text: this.$i18n.t("message.common.title"),
          value: 'name',
          filter: value => {
            if(this.search_corpus === "" || this.search_corpus === null){
              return true;
            }
            return value.indexOf(this.search_corpus) !== -1;
          }
        },
        {
          text: this.$i18n.t("message.common.lang_pair"),
          value: 'lang_pair',
          filter: value => {
            if(!Array.isArray(value)
              || !Array.isArray(this.lang_pairs)
              || value.length < 2
              || this.lang_pairs.length < 2){
              return false;
            }
            return (value[0] === this.lang_pairs[0] && value[1] === this.lang_pairs[1])
              || (value[0] === this.lang_pairs[1] && value[1] === this.lang_pairs[0]);
          }
        },
        { text: this.$i18n.t("message.corpus.line"), value: 'line' },
        { text: this.$i18n.t("message.common.ctime"), value: 'ctime' },
        {
          text: this.$i18n.t("message.common.operation"),
          value: 'operation',
          sortable: false
        },
      ];
    },
    max_priority: function(){
      return Math.max(...this.data.map((d) => d.priority));
    }
  }
}
</script>
<style scoped>
.circle {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  flex-flow: column;
  vertical-align: top;
  background: var(--v-primary-base);
  color: #fff;
  width: 24px;
  height: 24px;
}
</style>
